<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab
        v-for="item in items"
        :key="item.tab"
        @click.prevent="printTable = item.print"
      >
        <v-icon class="mr-2">{{ item.icon }}</v-icon>
        {{ translate(item.tab) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <company-report-tab-employee
          v-if="tab === 0"
          :loading="loading"
          :users="users"
        ></company-report-tab-employee>
      </v-tab-item>
      <v-tab-item>
        <company-report-tab-orders
          v-if="tab === 1"
        ></company-report-tab-orders>
      </v-tab-item>
      <v-tab-item>
        <company-report-tab-customers
          v-if="tab === 2"
        ></company-report-tab-customers>
      </v-tab-item>
      <v-tab-item>
        <company-report-tab-grouped-shift-meals
          v-if="tab === 3"
        ></company-report-tab-grouped-shift-meals>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reportService from "@/services/report";
import CompanyReportTabEmployee from "@/components/company/reports/tabs/CompanyReportTabEmployee.vue";
import CompanyReportTabOrders from "@/components/company/reports/tabs/CompanyReportTabOrders.vue";
import CompanyReportTabCustomers from "@/components/company/reports/tabs/CompanyReportTabCustomers.vue";
import CompanyReportTabGroupedShiftMeals from "@/components/company/reports/tabs/CompanyReportTabGroupedShiftMeals.vue";

export default {
  components: {
    CompanyReportTabEmployee,
    CompanyReportTabOrders,
    CompanyReportTabCustomers,
    CompanyReportTabGroupedShiftMeals,
  },
  data() {
    return {
      tab: 0,
      users: [],
      loading: false,
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      const companyIds = this.selectedCompanies.map((c) => c.id).join(",");
      if (!companyIds) {
        this.users = [];
        return;
      }
      this.loading = true;
      reportService
        .getCompanyFoodKorisnici(companyIds, {
          date: this.dates.from,
          date2: this.dates.to,
          without_orders: 1, // Isti odgovor bez niza orders (brze); vreme narudzbe je u ordered_at
        })
        .then((response) => {
          this.users = response.data.users;
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {
    items() {
      return [
        {
          tab: this.$t("user_overview"),
          icon: "mdi-account-settings",
        },
        {
          tab: this.$t("ordered_1"),
          icon: "mdi-grid",
        },
        {
          tab: this.$t("orderers"),
          icon: "mdi-format-list-bulleted-type",
        },
        {
          tab: this.$t("groups_meal"),
          icon: "mdi-food",
        },
      ];
    },
    company() {
      return this.$store.state.company;
    },
    dates() {
      return this.$store.state.report.filters.dates;
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies;
    },
  },
  watch: {
    selectedCompanies: {
      handler: function () {
        this.getUsers();
      },
      deep: true,
    },
    dates: {
      handler: function () {
        this.getUsers();
      },
      deep: true,
    },
    tab() {
      this.$root.$emit("changedTab", this.tab);
    },
  },
};
</script>
